import { useMutation, useQueryClient } from '@tanstack/react-query'

import { unlikeIdea, likeIdea } from '../api/fetchers/likeIdea'
import { postLikeIdea } from '../api/fetchers/postLikeIdea'

export interface LikeMutationResult {
  ideaId: string
  liked: boolean
  likesCount: number
}

export const toggleIdeaLike = async (params: {
  ideaId: string
  currentlyLiked: boolean
}): Promise<LikeMutationResult> => {
  const { ideaId, currentlyLiked } = params

  const producer = currentlyLiked ? unlikeIdea({ ideaId }) : postLikeIdea({ ideaId })
  const response = await producer(new AbortController().signal)

  return {
    ideaId,
    liked: Boolean(response.data.liked),
    likesCount: response.data.likesCount,
  }
}

export const useToggleIdeaLikeMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    // Using mutationKey enables in-flight de-duping behavior for the same key
    mutationKey: ['ideasBank', 'toggleIdeaLike'],
    mutationFn: toggleIdeaLike,
    onSuccess: () => {
      // If there are query results depending on like state, they can be invalidated here.
      // Keeping it conservative since state is mostly handled in the zustand store.
      void queryClient.invalidateQueries({ queryKey: ['highlightedIdeas'] })
    },
  })
}

